export default __webpack_public_path__ + "static/media/test-icon.60009183.svg";